/**
 * Vishram — live clock
 * Switches the line at 21:00: before → "Your day ends when you decide."
 * at/after → "It's time." Isolated so a clock failure can't break the cart gate.
 */
(function () {
  'use strict';

  if (window.__vishramLiveClockInit) {
    return;
  }
  window.__vishramLiveClockInit = true;

  try {
    var els = document.querySelectorAll('[data-vishram-live-clock]');
    var nodes = Array.prototype.slice.call(els);
    if (nodes.length === 0) {
      return;
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function render() {
      try {
        var now = new Date();
        var hours = now.getHours();
        var minutes = now.getMinutes();
        var timeString = pad(hours) + ':' + pad(minutes);
        var isEvening = hours >= 21;

        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          var timeEl = node.querySelector('[data-vishram-live-clock-time]');
          var lineEl = node.querySelector('[data-vishram-live-clock-line]');

          if (timeEl) {
            timeEl.textContent = timeString;
          }
          if (lineEl) {
            lineEl.textContent = isEvening
              ? lineEl.getAttribute('data-line-evening')
              : lineEl.getAttribute('data-line-day');
          }
          if (node.classList) {
            if (isEvening) {
              node.classList.add('is-evening');
            } else {
              node.classList.remove('is-evening');
            }
          }
        }
      } catch (innerErr) {
        if (window.console && window.console.error) {
          window.console.error('vishram live-clock render error', innerErr);
        }
      }
    }

    render();
    window.setInterval(render, 30000);
  } catch (err) {
    if (window.console && window.console.error) {
      window.console.error('vishram live-clock error', err);
    }
  }
})();
